import React from 'react';

import { Card, CardSection } from '@lightspeed/flame/Card';
import { Box } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { CustomerInfoDiv } from './ExistingCustomerSelection.style';
import { CfdCustomerDataInputs, CfdFormInfoProp } from './types';

export const DiffRenderer = ({
  dataInDb,
  newData,
  showMatch = false,
}: {
  dataInDb?: string;
  newData?: string;
  showMatch?: boolean;
}) => {
  const areSame = dataInDb === newData;
  let value = dataInDb;
  const newDataPresent = newData?.length;
  const bgColor =
    (showMatch && areSame) || (!showMatch && !areSame && newDataPresent) ? '#FFEDD4' : undefined;
  if (!areSame && !showMatch) {
    value = newData || dataInDb;
  }

  return value ? (
    <span key={`${dataInDb}-${newData}`} style={{ backgroundColor: bgColor, margin: '3px 0' }}>
      <var>{value}</var>
    </span>
  ) : null;
};

export const CustomerInfoDiff = ({
  title,
  dataInDb,
  formData,
}: CfdFormInfoProp & CfdCustomerDataInputs) => {
  if (dataInDb === undefined && formData === undefined) return null;

  const compareKeys = ['name', 'primaryEmail', 'mobilePhone'];

  const shouldShowDiff = dataInDb && formData;
  const dataSource = dataInDb || formData;

  const content = compareKeys.map((diffKey, idx) => {
    // @ts-ignore:
    const dbFieldData = dataSource?.[diffKey] as undefined | string;
    // @ts-ignore:
    const formFieldData = formData?.[diffKey] as undefined | string;

    return dbFieldData || formFieldData ? (
      <CustomerInfoDiv key={dbFieldData || formFieldData || idx}>
        {shouldShowDiff ? (
          <DiffRenderer dataInDb={dbFieldData} newData={formFieldData} />
        ) : (
          <var>{dbFieldData}</var>
        )}
      </CustomerInfoDiv>
    ) : null;
  });

  return (
    <Box>
      <Text fontWeight={700} color="#020203" marginBottom="6px">
        {title}
      </Text>
      <Card>
        <CardSection>{content}</CardSection>
      </Card>
    </Box>
  );
};
